<template>
  <div style="text-align: center;width: 100%;padding: 10px;background: #f3672a">
    <img src="https://sport.yazdgishe.ir/assets/img/logo-sport.svg" width="300"/>
  </div>
  <div style="width: 90%;margin: 10px auto">
    <select v-model="door" style="width: 100%;padding: 10px;height: 30px">
      <option value="1">میزبان</option>
      <option value="2">میهمان</option>
      <option value="3">vip</option>
      <option value="4">بانوان</option>
    </select>
    <template v-if="door!=''">
      <h2 v-if="selected=='200'"  style="background: #42b983;padding: 10px">{{desc}} </h2>
      <h2 v-if="selected=='401'"  style="background: red;color: #fff; padding: 10px">{{desc}} </h2>
      <h2 style="color: #fff; padding: 10px;background: black" v-if="data!=''" v-text="data"> </h2>
      <div @click="set" class="cler" style="width: 100%;margin: 10px auto;background: #2c3e50;color: #fff;padding: 10px;border-radius: 10px"  > اسکن جدید</div>
      <div style="width: 98%;height: 500px;margin: 20px auto">
        <qrcode-stream @detect="onDetect"></qrcode-stream>
      </div>
    </template>
  </div>
</template>

<script >
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import http from "@/plugins/axios";
export default {
  name: 'qr-scaner',

  data: () => ({
    selected: "",
    data: "",
    door: "",
    desc: "",
  }),
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  methods: {

    onDetect (detectedCodes) {

      let result;
      result = JSON.stringify(detectedCodes.map((code) => code.rawValue))
      this.get(result);
    },
    set(){
      this.selected="";
      this.data="";
      this.desc="";
    },
    get(data) {
      if(this.door==""){
        this.selected="لطفا جایگاه را مشخص کنید";
      }else{
        this.selected = "";
        this.data="";
        this.desc="";
        http.post("/api-check-ticket2",{
          qrcode : data,
          door : this.door
        })
            .then(response => {
              if(response.data.status==200 && this.door==response.data.door){
                this.selected = response.data.status;
                this.data = response.data.name_family+" "+response.data.national_code;
                this.desc=" مجاز"
              }
              else{
                this.selected = 401;
                this.data="";
                this.desc="غیرمجاز - "+response.data.desc;
              }

            });
      }
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.cler:hover{
  background: #45607e;
}
h2{
  text-align: center;
}
</style>